<template>
  <div>
    <div>我的上下级</div>

    <div class="fr ac mt20">
      <div v-if="higher_s">
        <div>我的大S</div>

        <div class="higher-s mt20 fr ac p20">
          <img :src="higher_s.member_img" style="width: 40px;height: 40px;border-radius: 50%" />

          <div class="ml10">
            <div>{{higher_s.member_nick_name}}</div>
            <div class="fz12 grey mt10">{{higher_s.member_account}}</div>
          </div>
        </div>
      </div>
      <div v-if="higher" style="margin-left: 130px">
        <div>我的上级</div>

        <div class="higher-s mt20 fr ac p20">
          <img :src="higher.member_img" style="width: 40px;height: 40px;border-radius: 50%" />

          <div class="ml10">
            <div>{{higher.member_nick_name}}</div>
            <div class="fz12 grey mt10">{{higher.member_account}}</div>
          </div>
        </div>
      </div>
    </div>

    <el-divider></el-divider>

    <div>
      <el-input style="width: 336px" v-model="search.member_account" placeholder="请输入昵称或手机号"></el-input>
      <el-button class="ml30" type="primary" style="width: 108px">搜索</el-button>
    </div>

    <!--    我的下级-->

    <div class="mt20">我的下级({{sub_member_list.length}})</div>

    <el-divider></el-divider>
    <!--    下级列表-->
    <div class="member-list">
      <div
        @click="toSubDetail(item)"
        class="item fr ac p20 cursor"
        style="border-bottom: 1px solid #f5f5f5;"
        v-for="(item,index) in sub_member_list"
        :key="index"
      >
        <img :src="item.member_img" alt style="width: 40px;height: 40px;border-radius: 50%" />

        <div class="ml20">
          <div>{{item.member_nick_name}}</div>

          <div class="mt10 grey fz12">{{item.member_account}}</div>
        </div>
      </div>
    </div>

    <div class="fr jc ac p50">
      <el-pagination
        background
        :current-page.sync="pagination.page"
        layout="prev, pager, next"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: {
        member_account: ""
      },
      pagination: {
        page: 1,
        total: 0
      },

      //下级member列表
      sub_member_list: [],
      //大s
      higher_s: {},
      //上级
      higher: {}
    };
  },
  mounted() {
    this.getHigherS();
    this.getHigher();
    this.getSubMemberList();
  },
  methods: {
    toSubDetail(sub_member_info) {
      this.$router.push({
        path: "/myRelation/subDetail",
        query: {
          sub_member_info: JSON.stringify(sub_member_info)
        }
      });
    },

    //  获取大s
    getHigherS() {
      this.post("memberInterfaces/v1.0/getMyHigherS").then(res => {
        if (JSON.stringify(res.data) == "{}") {
          res.data = "";
        }
        this.higher_s = res.data;
      });
    },
    //  获取上级
    getHigher() {
      this.post("memberInterfaces/v1.0/getMyHigher").then(res => {
        if (JSON.stringify(res.data) == "{}") {
          res.data = "";
        }
        this.higher = res.data;
      });
    },
    //  我的下级
    getSubMemberList() {
      let param = {
        invite_code: this.$store.state.memberInfo.invite_code,
        parent_id: this.$store.state.memberInfo.member_id
      };
      this.post("memberInterfaces/v1.0/getSubSaleList", param).then(res => {
        this.sub_member_list = res.data;
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.higher-s {
  width: 211px;
  height: 81px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/page/me/myRelation/index.vue